<template lang="">
  <div id="content">
    <div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">관리자 관리</a> &gt; <strong>관리자 생성 및 관리</strong></div>
			<h2 class="h_sub">관리자 생성 및 관리 <span class="fs_regular">[보기&amp;수정]</span></h2>
		</div>

    <AdminAccountCreateForm/>
  </div>
</template>
<script>
import AdminAccountCreateForm from '@/components/admin/account/AdminAccountCreateForm.vue'

export default {
  data () {
    return {
      newAccount: false,
    }
  },
  components: {
    AdminAccountCreateForm
  },

  methods: {
  },
}
</script>
<style lang="">
    
</style>